import React, { useEffect, useState } from "react";

import AccordionEmpreendimentos from "./components/accordioEmpreendimentos";
import useEmpreendimentos from "./hooks/useEmpreendimentos";
import SelecaoPeriodos from "./components/selecaoPeriodos";
import {
  Content,
  CTA,
  Form,
  Input,
  Label,
  Paragraph,
  SuccessBox,
  Title,
  Wrapper,
} from "./styles";
import { useMessage } from "../../uteis/mensagens/useMessage";
import { useCadastrarPostagem } from "../ViewGerenciarPostagens/hooks/useCadastrarPostagem";
import { PostagemData } from "../ViewGerenciarPostagens/Interface/PostagemData";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Globais from "../../components/Globais";
import { useMessagemPessoa } from "./hooks/useMessagemPessoa";
import { RadarLoadingOverlay } from "./components/radarLoadingOverlay";


const QueroViajar = () => {
  const { showError, showWarning, contextHolder } = useMessage();
  const { cadastrar, isLoadingCadastro } = useCadastrarPostagem();
  const { atualizar } = useMessagemPessoa();

  const [nome, setNome] = useState("");
  const [quantidadePessoas, setQuantidadePessoas] = useState<number | null>(
    null
  );
  const [origem, setOrigem] = useState("");

  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [destino, setDestino] = useState("");

  const [periodosSelecionados, setPeriodosSelecionados] = useState<any[]>([]);

  const [cidadesSelecionadas, setCidadesSelecionadas] = useState<number[]>([]);

  // Exemplo de lista de empreendimentos (ajuste conforme necessário)
  // Dentro do componente QueroViajar
  const { empreendimentos, isLoading } = useEmpreendimentos(true); // ou passe parâmetros se necessário
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const objetivos = ["alugar"];


  // 👉 Marca mensagem como CLICADA no backend assim que a página carrega
  useEffect(() => {
    if (token) {
      atualizar(token, { statusMensagem: "CLICADA" });
     
    }
  }, [token]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!cidadesSelecionadas.length) {
      showWarning("Selecione ao menos um destino.");
      return;
    }

    if (!periodosSelecionados.length) {
      showWarning("Selecione ao menos um período.");
      return;
    }

    if (!telefone) {
      showWarning("Informe seu número de celular.");
      return;
    }

    const dados: any = {
      nome,
      email,
      telefone,
      destino,
      origem,
      quantidadePessoas,
      cidadesSelecionadas,
      periodosSelecionados,
    };

    localStorage.setItem("interesseViagem", JSON.stringify(dados));
    try {
      for (const periodo of periodosSelecionados) {
        for (const idEmpreendimento of cidadesSelecionadas) {
          const data: PostagemData = {
            nome,
            celular: telefone,
            fonte: "site",
            grupo: "sem Grupo",
            idEmpreendimento,
            active: 1,
            dataDivulgacao: new Date().toISOString(),
            tipoInteresse: "PROCURA",
            troca: 0,
            aluguel: 1,
            compra: 0,
            venda: 0,
            dataIni: new Date(periodo.inicio).toISOString(),
            dataFim: new Date(periodo.fim).toISOString(),
            observacoes:
              "Quantidade de pessoas: " +
              quantidadePessoas +
              " " +
              "Cidade Origem: " +
              origem,
          };

          const resultadoCadastro = await cadastrar(data, objetivos);
          if (!resultadoCadastro?.sucesso) {
            showError("Ocorreu um erro ao cadastrar. Tente novamente.");
            return;
          } else {
            // 👉 Marca mensagem como RESPONDIDA no backend após submit
            if (token) {
              atualizar(token, {
                statusMensagem: "RESPONDIDA",
                dataResposta: new Date(),
              });
            }
            document.location.href = "/agradecimentocadastrointeresseviagem";
          }
        }
      }

      // setEnviado(true);
    } catch (error) {
      console.error("Erro ao cadastrar:", error);
      showError("Ocorreu um erro ao cadastrar. Tente novamente mais tarde.");
      return;
    }
  };

  return (
    <Wrapper>
      {contextHolder}
      <RadarLoadingOverlay visible={isLoadingCadastro} />

      <Content>
        <Title>🌍 Para onde você gostaria de viajar?</Title>

        <Paragraph>
          Após se cadastrar conosco você se tornou parceiro da Multicotas e,
          assim sendo, tem direito a descontos exclusivos. <br />
          Nos conte o destino e o período que tem interesse — assim podemos te
          avisar quando aparecer uma oportunidade ideal para você. <br /> Seja
          de hospedagem, seja de passagem aérea.
        </Paragraph>

        <Form onSubmit={handleSubmit}>
          <Label>Para onde você gostaria de ir?</Label>
          {isLoading ? (
            <p>Carregando empreendimentos...</p>
          ) : (
            <AccordionEmpreendimentos
              empreendimentos={empreendimentos}
              onChange={(idsSelecionados) => {
                console.log("IDs selecionados:", idsSelecionados);
                setCidadesSelecionadas(idsSelecionados);
              }}
            />
          )}

          <SelecaoPeriodos
            onChange={(periodos) => {
              console.log("Períodos selecionados:", periodos);
              setPeriodosSelecionados(periodos);
            }}
          />

          <Label>Quantas pessoas irão?</Label>
          <select
            value={quantidadePessoas || ""}
            onChange={(e) => setQuantidadePessoas(parseInt(e.target.value))}
            required
            style={{
              width: "100%",
              padding: "0.9rem",
              marginBottom: "1.5rem",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "1rem",
            }}
          >
            <option value="">Selecione</option>
            {[...Array(10)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1} pessoa{i > 0 ? "s" : ""}
              </option>
            ))}
          </select>

          <Label>De qual cidade você pretende sair?</Label>
          <Input
            type="text"
            placeholder="Ex: São Paulo"
            value={origem}
            onChange={(e) => setOrigem(e.target.value)}
            required
          />

          <Label>Nome</Label>
          <Input
            type="text"
            placeholder="Seu nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
          />

          <Label>E-mail</Label>
          <Input
            type="email"
            placeholder="seu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <Label>Nº Celular</Label>
          <PhoneInput
            country="br"
            onChange={(telefone) => {
              setTelefone(telefone);
            }}
            placeholder="(DDD) 90000-0000"
            inputClass="phone-input"
          />

          <div style={{ marginTop: "30px" }}>
            <CTA type="submit">📩 Quero ser avisado</CTA>
          </div>
        </Form>
      </Content>
    </Wrapper>
  );
};

export default QueroViajar;
